import React from 'react';
require ('./Toast.scss');

const Toast = () => (
	<div className="Toast">
		<div className="Toast-container"></div>
	</div>
);

export default Toast;



/** WEBPACK FOOTER **
 ** ./src/components/Toast/Toast.js
 **/